export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-32 border-t border-[var(--ff-border)] bg-[var(--ff-muted)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <h3 className="font-display text-3xl text-[var(--ff-primary)]">The Farm To You</h3>
          <p className="mt-3 text-[var(--ff-text-secondary)] max-w-md leading-relaxed">
            A members-only farm-to-door drop platform. Real American farms. Real food. Exclusive limited releases.
            Delivered with care, harvested with pride.
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-3">Shop</p>
          <ul className="space-y-2 text-sm" data-testid="footer-shop">
            <li><a href="/marketplace" data-testid="footer-link-marketplace">Marketplace</a></li>
            <li><a href="/drops" data-testid="footer-link-drops">Curated Drops</a></li>
            <li><a href="/recipes" data-testid="footer-link-recipes">Recipes</a></li>
            <li><a href="/ranchers" data-testid="footer-link-farms">Meet Our Ranchers</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-3">Company</p>
          <ul className="space-y-2 text-sm" data-testid="footer-company">
            <li><a href="/about" data-testid="footer-link-about">About Us</a></li>
            <li><a href="/pricing" data-testid="footer-link-membership">Memberships</a></li>
            <li><a href="/sell" data-testid="footer-link-apply">Sell on Farm To You</a></li>
            <li><a href="/legal" data-testid="footer-link-legal">Policies &amp; Standards</a></li>
            <li><a href="/ambassadors" data-testid="footer-link-ambassador">Ambassador Program</a></li>
            <li><a href="/terms" data-testid="footer-link-terms">Terms &amp; Conditions</a></li>
            <li><a href="/privacy" data-testid="footer-link-privacy">Privacy Policy</a></li>
            <li><a href="/sms-terms" data-testid="footer-link-sms">SMS Terms</a></li>
            <li><a href="/contact" data-testid="footer-link-contact">Contact</a></li>
            <li><span className="text-[var(--ff-text-muted)]" data-testid="footer-link-careers">Careers · coming soon</span></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-3">Support</p>
          <ul className="space-y-2 text-sm" data-testid="footer-support">
            <li><a href="/how-it-works" data-testid="footer-link-how">How it Works</a></li>
            <li><a href="/faq" data-testid="footer-link-faq">FAQ</a></li>
            <li><a href="/referrals/leaderboard" data-testid="footer-link-leaderboard">Referral Leaderboard</a></li>
            <li><a href="/legal/refund-policy" data-testid="footer-link-refund">Refund &amp; Cancellation</a></li>
            <li><a href="/legal/shipping-policy" data-testid="footer-link-shipping">Shipping Policy</a></li>
            <li><a href="/legal/food-safety" data-testid="footer-link-food-safety">Food Safety &amp; Quality</a></li>
            <li><a href="/login" data-testid="footer-link-signin">Sign in</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--ff-border)]">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-[var(--ff-text-muted)] flex flex-col md:flex-row justify-between gap-2">
          <span>© {year} The Farm To You, LLC. Family farms, coast to coast.</span>
          <span className="flex items-center gap-4">
            <a href="/terms" className="hover:underline">Terms</a>
            <a href="/privacy" className="hover:underline">Privacy</a>
            <span>Made in America.</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
